import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import API from "../../helpers/API";

import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  REFRESH_JWT,
  REFRESH_JWT_FAILURE,
  REFRESH_JWT_SUCCESS,
} from "../actions";

import {
  loginUserSuccess,
  loginUserError,
  registerUserSuccess,
  registerUserError,
  forgotPasswordSuccess,
  forgotPasswordError,
} from "./actions";

import { push } from "react-router-redux";
import apiAuth from "../../helpers/ApiAuth";

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const loginWithEmailPasswordAsync = async (email, password) =>
  await API.post("/api/token/", {
    username: email,
    password: password,
  })
    .then((authUser) => {
      console.log(authUser.data);
      localStorage.setItem("currentUser", authUser.data?.username);
      return authUser.data;
    })
    .catch((error) => {
      if (error.response.status === 401) {
        return { message: "Incorrect Credentials" };
      }
      return error;
    });

const getLoginEntityAsync = async (groups) => {
  if (groups?.length > 0) {
    return await apiAuth
      .get("/api/admin/entity/view/")
      .then((res) => {
        let obj = {};
        let flag = true;
        res.data.map((item) => {
          if (item?.id === 123 && flag) {
            localStorage.setItem("currentEntity", JSON.stringify(item));
            localStorage.setItem("currentId", item.id);
            localStorage.setItem("isssss", true);
            localStorage.setItem("sroles", JSON.stringify(groups));
            obj["entity"] = item.id;
            flag = false;
          }
        });

        return obj;
      })
      .catch((err) => {
        console.log(err);
        return {};
      });
  } else {
    return await apiAuth
      .get("/api/entity/view/")
      .then((res) => {
        let data = res.data;
        let obj = {};
        if (data.length > 0) {
          localStorage.setItem("currentEntity", JSON.stringify(data[0]));
          localStorage.setItem("currentId", data[0]?.id);
          obj["entity"] = data[0]?.id;
        }

        return obj;
      })
      .catch((err) => {
        console.log(err);
        return {};
      });
  }
};

const getLoginCommunityRoles = async (entity, user) =>
  await apiAuth
    .get("/api/community/permission/?entity=" + entity + "&user=" + user)
    .then((res) => {
      let data = res.data;
      localStorage.setItem("communityrole", JSON.stringify(data));
      return data;
    })
    .catch((err) => {
      console.log(err);
      return {};
    });

function* loginWithEmailPassword({ payload }) {
  const { email, password, level, role } = payload.user;
  const { history } = payload;
  try {
    let loginUser = yield call(loginWithEmailPasswordAsync, email, password);

    if (!loginUser.message) {
      // console.log(loginUser);

      loginUser["user_level"] = level;
      loginUser["user_level_role"] = role;

      // localStorage.setItem("user_level", level);
      // localStorage.setItem("user_level_", role);

      localStorage.setItem("authUser", loginUser.groups[0]);

      localStorage.setItem("jwt", loginUser.access);
      localStorage.setItem("jwtRefresh", loginUser.refresh);

      localStorage.setItem("dark_mode", loginUser.profile.dark_mode);

      localStorage.setItem(
        "profile_picture",
        loginUser.profile.profile_picture
      );

      let entityDetail = yield call(getLoginEntityAsync, loginUser?.groups);

      if (entityDetail?.entity) {
        let communityrole = yield call(
          getLoginCommunityRoles,
          entityDetail.entity,
          loginUser?.user_id
        );

        loginUser["community_role"] = communityrole;

        yield put(loginUserSuccess(loginUser));
        history.push("/");
      } else {
        yield put(loginUserError("Something went wrong. Please try again."));
      }
    } else {
      yield put(loginUserError(loginUser.message));
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

const registerWithEmailPasswordAsync = async (email, password) =>
  await await API.post("/api/userauth/registration/", {
    email: email,
    password1: password,
    password2: password,
  })
    .then((authUser) => authUser)
    .catch((error) => error);

function* registerWithEmailPassword({ payload }) {
  const { email, password } = payload.user;

  try {
    const registerUser = yield call(
      registerWithEmailPasswordAsync,
      email,
      password
    );
    if (!registerUser.data.detail) {
      yield put(registerUserSuccess(registerUser));
    } else {
      yield put(registerUserError(registerUser.data));
    }
  } catch (error) {
    yield put(registerUserError(error));
  }
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  history.push("/");

  localStorage.removeItem("jwt");
  localStorage.removeItem("jwtRefresh");
  localStorage.removeItem("dark_mode");
  localStorage.removeItem("channel_name");
  localStorage.removeItem("profile_picture");
  localStorage.clear();
};

function* logout({ payload }) {
  if (payload === undefined) {
    try {
      yield call(logoutAsync, async () => {
        push("/");

        localStorage.removeItem("jwt");
        localStorage.removeItem("jwtRefresh");
        localStorage.removeItem("dark_mode");
        localStorage.removeItem("profile_picture");
      });
    } catch (error) {}
  } else {
    const { history } = payload;
    try {
      yield call(logoutAsync, history);
    } catch (error) {}
  }
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (email) => {
  return await await API.post("/api/password/request_reset/", {
    email: email,
  })
    .then((result) => result.data)
    .catch((error) => error);
};

function* forgotPassword({ payload }) {
  const { email } = payload.forgotUserMail;
  try {
    const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
    if (!forgotPasswordStatus.info) {
      yield put(forgotPasswordError(forgotPasswordStatus));
    } else {
      yield put(forgotPasswordSuccess("success"));
    }
  } catch (error) {
    yield put(forgotPasswordError(error));
  }
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePassword);
}

const changePasswordAsync = async (passwords) => {
  return await apiAuth
    .post("/api/password/update/", passwords)
    .then((result) => result.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* changePassword({ payload }) {
  try {
    const changePasswordStatus = yield call(changePasswordAsync, payload);
    console.log(changePasswordStatus);
    if (!changePasswordStatus.message) {
      console.log(changePasswordStatus);
      yield put({ type: CHANGE_PASSWORD_SUCCESS, payload: payload });
    } else {
      console.log(changePasswordStatus.message);
      yield put({
        type: CHANGE_PASSWORD_ERROR,
        payload: { message: changePasswordStatus.message.response.status },
      });
    }
  } catch (error) {
    yield put({
      type: CHANGE_PASSWORD_ERROR,
      payload: { message: error },
    });
  }
}

export function* watchUpdateProfile() {
  yield takeEvery(UPDATE_PROFILE, updateProfile);
}

function* updateProfile({ payload }) {
  try {
    localStorage.setItem("dark_mode", payload.dark_mode);
    localStorage.setItem("profile_picture", payload.profile_picture);
    yield put({ type: UPDATE_PROFILE_SUCCESS, payload: payload });
  } catch (error) {
    yield put({
      type: UPDATE_PROFILE_ERROR,
      payload: { message: error },
    });
  }
}

export function* watchRefreshJWT() {
  yield takeEvery(REFRESH_JWT, refreshJWT);
}

const refreshJWTAsync = async () => {
  return await apiAuth
    .post("/api/token/refresh/", {
      refresh: localStorage.getItem("jwtRefresh"),
    })
    .then((result) => result.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });
};

function* refreshJWT() {
  try {
    const access = yield call(refreshJWTAsync);

    yield put({ type: REFRESH_JWT_SUCCESS, payload: access.access });
    localStorage.setItem("jwt", access.access);
  } catch (error) {
    yield put({
      type: REFRESH_JWT_FAILURE,
      payload: { message: error },
    });
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRefreshJWT),
    fork(watchUpdateProfile),
    fork(watchChangePassword),
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchForgotPassword),
  ]);
}
